import Vue from 'vue';
import Vuex from 'vuex';

import backgroundLayers from './backgroundLayers.module';
import broadbandConnectionAnalysis from './broadbandConnectionAnalysis.module';
import compositions from './compositions.module';
import contextAssistantModule from './contextAssistant.module';
import decision from './decision.module';
import editSession from './editSession.module';
import features from './features.module';
import historyTable from './historyTable.module';
import historyTimeline from './historyTimeline.module';
import keyShortcuts from './keyShortcuts.module';
import layers from './layers.module';
import map from './map.module';
import measurements from './measurements.module';
import mismatch from './mismatch.module';
import poleAnalysis from './poleAnalysis.module';
import readOnly from './readOnly.module';
import reports from './reports.module';
import responsiveness from './responsiveness.module';
import responsiveVersionModule from './responsiveVersion.module';
import roadLaneOccupationAnalysis from './roadLaneOccupationAnalysis.module';
import search from './search.module';
import select from './select.module';
import setFeatureGeometry from './setFeatureGeometry.module';
import spatialAnalysisModal from './spatialAnalysis.module';
import spatialTabs from './spatialTabs.module';
import storedSettings from './storedSettings.module';
import temporaryLayers from './temporaryLayers.module';
import tools from './tools.module';
import windows from './windows.module';
import session from './session.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    compositions,
    editSession,
    features,
    keyShortcuts,
    map,
    reports,
    tools,
    windows,
    spatialAnalysisModal,
    temporaryLayers,
    poleAnalysis,
    spatialTabs,
    measurements,
    readOnly,
    responsiveness,
    search,
    mismatch,
    select,
    roadLaneOccupationAnalysis,
    historyTable,
    broadbandConnectionAnalysis,
    setFeatureGeometry,
    decision,
    layers,
    backgroundLayers,
    storedSettings,
    responsiveVersionModule,
    contextAssistantModule,
    historyTimeline,
    session
  }
});
